import { Badge } from "@chakra-ui/react";

const STATUS_STYLES = {
    New: { bg: "gray.600", borderColor: "gray.400", label: "Nowy" },
    ContactAttempted: { bg: "blue.700", borderColor: "blue.400", label: "Próba kontaktu" },
    Contacted: { bg: "blue.600", borderColor: "blue.300", label: "Skontaktowano" },
    Conversation: { bg: "blue.500", borderColor: "blue.200", label: "Rozmowa" },
    Qualifying: { bg: "purple.700", borderColor: "purple.400", label: "Kwalifikacja" },
    Qualified: { bg: "purple.500", borderColor: "purple.200", label: "Zakwalifikowany" },
    Interested: { bg: "teal.600", borderColor: "teal.300", label: "Zainteresowany" },
    ConversionProposed: { bg: "teal.500", borderColor: "teal.200", label: "Zaproponowano konwersję" },
    Converted: { bg: "green.500", borderColor: "green.200", label: "Skonwertowany" },
    NotInterested: { bg: "orange.600", borderColor: "orange.300", label: "Niezainteresowany" },
    NoResponse: { bg: "orange.700", borderColor: "orange.400", label: "Brak odpowiedzi" },
    Disqualified: { bg: "red.600", borderColor: "red.300", label: "Zdyskwalifikowany" },
    HandedToHuman: { bg: "yellow.600", borderColor: "yellow.300", label: "Przekazano do człowieka" },
};

export const LeadStatusBadge = ({ status, badgeStyles }) => {
    const { bg, borderColor, label } = STATUS_STYLES[status] ?? { bg: "gray.600", borderColor: "gray.400", label: status ?? "-" };

    return (
        <Badge bg={bg} borderColor={borderColor} borderWidth={1} variant="subtle" fontSize="xs" px={3} py={0.5} borderRadius={6} {...badgeStyles}>
            {label}
        </Badge>
    );
};

export default LeadStatusBadge;
